import { render } from "./YouChatBotSettings.vue?vue&type=template&id=2bc36362"
import script from "./YouChatBotSettings.vue?vue&type=script&lang=js"
export * from "./YouChatBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__